<div class="col-sm-12 p-4">
  <div class=" m-0">
    <div class="container-fluid">
      <div class="row">
        <div>
          <div class="row">
            <div class="row col-12">
              <!--Penalty-*ngIf="decsionId==2

                                 *ngIf="
       (roleId == 4 && DecsionOList == null)
                     "



    *ngIf="

                                   caseObject.options.allowToDeletePenalties
                                   && (roleId == 4 && DecsionOList == null)"
                             -->
              <div class="row col-12">
                <!--<h4 class="text-center">{{ "Penalties" | translate }}</h4>
                        <br />-->
                <div class="card">
                  <div class="row">
                    <div class="col-12">
                      <button (click)="CreatePenalty(AddPenalty)"
                        *ngIf="caseObject!=null && caseObject.options.allowToAddPenalties"
                        class="btn btn-secondary m-2">
                        <i class="fa fa-plus"></i> {{ "InsertPenalty" | translate }}
                      </button>
                    </div>
                  </div>
                  <div class="card-body">
                    <table class="table table-striped mt-3">
                      <thead class="thead-dark">
                        <tr>
                          <th scope="col">{{"typePenalty" | translate}}</th>
                          <th scope="col">{{"ReporterViolationName" | translate}}</th>
                          <th scope="col">{{ "Description" | translate}}</th>
                          <th scope="col">{{ "PenaltyTitle" | translate }}</th>
                          <th scope="col">{{ "SadadNumber" | translate }}</th>
                          <th scope="col">{{ "PenaltyAmount" | translate }}</th>
                          <th scope="col">{{"statusSadd" | translate}}</th>
                          <th scope="col">{{'reportDetails' | translate }}</th>

                          <th *ngIf="caseObject!=null && caseObject.options.allowToAddPenalties">
                            {{ "Edit" | translate }}
                          </th>
                          <th scope="col" *ngIf="caseObject!=null && caseObject.options.allowToAddPenalties">
                            {{ "Delete" | translate }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of CasePenaltiesList">
                          <td>{{ item.isOnCR ? "عقوبة علي سجل تجاري"  : "عقوبة علي شخص" }}</td>
                          <td *ngIf="item.isOnCR==true">{{ item.crRelatedPrsonName ? item.crRelatedPrsonName : "-" }}</td>

                          <td *ngIf="item.isOnCR==false">{{ item.memberName ? item.memberName : "-" }}</td>
                          <td>
                            <p style="margin-bottom: 0;"><span style="font-weight: bold;">{{"PenaltyDescription" |
                                translate}}</span> {{ item.description }}</p>
                            <p><span style="font-weight: bold;">{{'Violation'|translate}}</span> {{ item.violationName }}</p>
                          </td>
                          <td>{{ item.penaltyTitle }} - {{item.isFinancial?"مالية":"ادارية"}}</td>
                          <td>{{ item.sadadNumber ? item.sadadNumber : "-" }}</td>
                          <td>{{ item.amount ? item.amount : "-" }}</td>
                          <td>{{ item.invoiceStatusName ? item.invoiceStatusName : "-" }}</td>
                          <td>
                            <a (click)="ShowRecivers(item, Recivers)">
                              <i class="fa fa-users"></i>
                            </a>

                          </td>
                          <td *ngIf="caseObject!=null && caseObject.options.allowToAddPenalties">
                            <a class="m-2" (click)="EditPenalty(item, Edit)">
                              <i class="fa fa-edit"></i>
                            </a>
                          </td>
                          <td *ngIf="caseObject!=null && caseObject.options.allowToAddPenalties">
                            <a (click)="DeletePenalty(item, mymodal)">
                              <i class="fa fa-trash"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!--End Penalities-->
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>


  <ng-template #AddPenalty let-modal>
    <div class="modal-header" style="justify-content: center">
      <h4 class="modal-title" id="modal-basic-title">
        {{ "InsertPenalty" | translate }}
      </h4>
    </div>
    <div class="modal-body">
      <div class="custom-form ">
        <div class="col-12 offset-1">

          <div class="card p-1">
            <div class="form-group row mt-1">
              <div class="col-lg-6">
                <div
                  class="custom-control custom-checkbox"
                  style="display: flex; align-items: center"
                >
                  <input [checked]="inputMethod == 'onCr'" (change)="inputMethodSelect('onCr')" type="radio"name="inputMethod" />
                  <label style="margin-top: 4px">
                    <span>{{ "onCr" | translate }}</span>
                  </label>
                </div>
              </div>
              <div class="col-lg-6">
                <div
                  class="custom-control custom-checkbox"
                  style="display: flex; align-items: center"
                >
                  <input
                    [checked]="inputMethod == 'onPerson'"
                    (change)="inputMethodSelect('onPerson')"
                    type="radio"
                    name="inputMethod"
                  />
                  <label style="margin-top: 4px">
                    <span>{{ "onPerson" | translate }}</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="form-group mt-1" *ngIf="isOnCRViolation==true">
                <div class="divformlabel">
                  <label for="PersonsCompanyName"> {{ "PersonsInCompanyOrInstitution" | translate }} </label>
                  <span *ngIf="PersonsCompanyName.invalid && PersonsCompanyName.errors?.required" class="alert error-span">*</span>
                </div>
                
                <ng-select id="personName" required #PersonsCompanyName="ngModel" class="form-control-select" [(ngModel)]="personsInCompanyAddPersonModalId" [ngModelOptions]="{ standalone: true }"
                  placeholder="{{ 'PersonsInCompanyOrInstitution' | translate }}" (change)="selectPersonINCompany($event)" >
                  <ng-option *ngFor="let person of personsInCompanyAddPersonModalArr" [value]="person" >
                    {{person.name}}
                  </ng-option>
                </ng-select>
            </div>
            <div class="form-group mt-1" *ngIf="isOnCRViolation==false">
              <div style="display: flex; flex-wrap: nowrap; height: 30px">
                <label for="offenderName">المخالف</label>
              </div>

              <ng-select  class="form-control-select"
                [items]="fillterList" bindLabel="name" bindValue="personId" [(ngModel)]="offenderIds" required
                #Offenders="ngModel" [ngModelOptions]="{ standalone: true }"
                placeholder="{{ 'offenderName' | translate }} ">
              </ng-select>
           
            </div>
              <div class="form-group ">

                <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                  <label for="typePenalty"> {{ "typePenalty" | translate }}</label>

                </div>
                <ng-select [items]="PenaltyArr" bindLabel="penaltyTitle" bindValue="penaltyId"
                  class="form-control-select" [(ngModel)]="penaltyId" [ngModelOptions]="{ standalone: true }"
                  (change)="selectItem($event)" placeholder="{{ 'typePenalty' | translate }}">
                </ng-select>
              </div>
              <div class="form-group mt-1">
                <div style="display: flex; flex-wrap: nowrap; height: 30px">
                  <label for="">{{ "PenaltyDescription" | translate }} : </label>
                  <span *ngIf="Desc.invalid" class="alert" style="color: #ff0000; white-space: nowrap; line-height: 0">
                    <div *ngIf="Desc.errors?.required">*</div>
                    <div *ngIf="Desc.errors?.pattern">
                      {{ "ThisIsNotValidDescription" | translate }}
                    </div>
                  </span>
                </div>

                <textarea [(ngModel)]="penaltyDescription" class="form-control"
                  pattern="^[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z\s]+[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z\s-_]*$"
                  name="penaltyDescription" required #Desc="ngModel"></textarea>
              </div>
              <div class="form-group mt-1">
                <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                  <label for="Violation"> {{'Violation'|translate}} </label>
                  <span *ngIf="Violation.invalid" class="alert"
                    style="color: red; white-space: nowrap;line-height: 0; padding: 0; margin-top: 8px;">
                    <div *ngIf="Violation.errors?.required">
                      *
                    </div>
                  </span>
                </div>
                <ng-select required #Violation="ngModel" id="Violation" class="form-control-select"
                  [items]="violationArr" bindLabel="text" bindValue="id" [(ngModel)]="violationId"
                  [ngModelOptions]="{standalone: true}" placeholder="{{'Violation'|translate}}">
                </ng-select>
              </div>
            

              <br />
              <div class="custom-control custom-checkbox">

                <span *ngIf="isFinancial&&penaltyId>0">نوع العقوبة : عقوبة مالية</span>
                <span *ngIf="(!isFinancial) && penaltyId>0">نوع العقوبة : عقوبة ادارية</span>


              </div>

              <div class="form-group mt-1">
                <div style="display: flex; flex-wrap: nowrap; height: 30px">
                  <label for="amoutPenalty">{{ "PenaltyAmount" | translate }}</label>
                </div>

                <input [readonly]="!isFinancial" #AmoutPenalty="ngModel" [(ngModel)]="amount" type="number"
                  class="form-control" id="amoutPenalty" min="{{minAmountPenality}}" max="{{maxAmountPenality}}"
                  name="amoutPenalty" required [ngModelOptions]="{ standalone: true }" />
                <span *ngIf="AmoutPenalty.invalid" class="alert" style="
                  color: red;
                  white-space: nowrap;
                  line-height: 0;
                  padding: 0;
                  margin-top: 8px;
                ">
                  <div *ngIf="AmoutPenalty.errors?.min">قيمة العقوبة أقل من الحد الأدني للعقوبة ({{minAmountPenality}})
                  </div>
                  <div *ngIf="AmoutPenalty.errors?.max"> قيمة العقوبة أكثر من الحد الأقصي للعقوبة
                    ({{maxAmountPenality}})</div>

                </span>
              
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        [disabled]=" Desc.invalid || (isFinancial == true && AmoutPenalty.invalid )  "
        type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="OnCreatePenalty()">
        {{ "Add" | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="notCreatePenalty()">
        {{ "NO" | translate }}
      </button>
    </div>
  </ng-template>

  <ng-template #mymodal let-modal>
    <div class="modal-header" style="justify-content: center">
      <h4 class="modal-title" id="modal-basic-title">
        {{ "ConfirmDeleteOperation" | translate }}
      </h4>
    </div>
    <div class="modal-body text-center">
      <p>{{ "SelectedRecordwillbeDeleted" | translate }}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger" (click)="onDeletePenalty()">
        {{ "YES" | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')" (click)="deleteChecked()">
        {{ "NO" | translate }}
      </button>
    </div>
  </ng-template>

  <ng-template #Edit let-modal>
    <div class="modal-header" style="justify-content: center">
      <h4 class="modal-title" id="modal-basic-title">
        تعديل العقوبة
      </h4>
    </div>
    <div class="modal-body">
      <div class="custom-form ">
        <div class="col-12 offset-1">

          <div class="card p-1">
            
            <div class="form-group mt-1" *ngIf="casePenaltyEdited.isOnCR==true">
                <div class="divformlabel">
                  <label for="PersonsCompanyName"> {{ "PersonsInCompanyOrInstitution" | translate }} </label>
                  <span *ngIf="PersonNameEdit.invalid && PersonNameEdit.errors?.required" class="alert error-span">*</span>
                </div>
                <input
                  id="PersonNameEdit"
                  required
                  #PersonNameEdit="ngModel"
                  class="form-control"
                  [(ngModel)]="crRelatedPrsonName"
                  type="text"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="{{ 'personName' | translate }}"
                />
            </div>
            <div class="form-group mt-1" *ngIf="casePenaltyEdited.isOnCR==false">
                <div style="display: flex; flex-wrap: nowrap; height: 30px">
                  <label for="offenderName">{{"Offenders" | translate}}</label>
                </div>
    
                <ng-select 
                  class="form-control-select" [items]="casePenaltyEdited.casePenaltyOffenders" bindLabel="name"
                  bindValue="personId" [(ngModel)]="offenderEdited" #OFFENDEREdit="ngModel"
                  [ngModelOptions]="{ standalone: true }" placeholder="{{ 'offenderName' | translate }} ">
                </ng-select>
               </div>
            <div class="form-group mt-1">
            <p style="font-weight: bold">
              {{ "typePenalty" | translate }}
            </p>
            <ng-select [items]="PenaltyArr" bindLabel="penaltyTitle" bindValue="penaltyId" class="form-control-select"
              [(ngModel)]="casePenaltyEdited.penaltyId" [ngModelOptions]="{ standalone: true }"
              (change)="selectItem($event)" placeholder="{{ 'typePenalty' | translate }}">
            </ng-select>
          </div>
          <div class="form-group mt-1">
            <div style="display: flex; flex-wrap: nowrap; height: 30px">
              <label for="">{{ "PenaltyDescription" | translate }} : </label>
              <span *ngIf="PenaltyDescription.invalid" class="alert"
                style="color: #ff0000; white-space: nowrap; line-height: 0">
                <div *ngIf="PenaltyDescription.errors?.required">*</div>
                <div *ngIf="PenaltyDescription.errors?.pattern">
                  {{ "ThisIsNotValidDescription" | translate }}
                </div>
              </span>
            </div>

            <textarea [(ngModel)]="casePenaltyEdited.description" class="form-control"
              pattern="^[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z\s]+[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z\s-_]*$"
              name="penaltyDescription" required #PenaltyDescription="ngModel"></textarea>
          </div>
          <div class="form-group mt-1">
            <div style="display: flex; flex-wrap: nowrap; height: 30px;">
              <label for="Violation"> {{'Violation'|translate}} </label>
              <span *ngIf="Violation.invalid" class="alert"
                style="color: red; white-space: nowrap;line-height: 0; padding: 0; margin-top: 8px;">
                <div *ngIf="Violation.errors?.required">
                  *
                </div>
              </span>
            </div>
            <ng-select required #Violation="ngModel" id="Violation" class="form-control-select" [items]="violationArr"
              bindLabel="text" bindValue="id" [(ngModel)]="casePenaltyEdited.violationId"
              [ngModelOptions]="{standalone: true}" placeholder="{{'Violation'|translate}}">
            </ng-select>
          </div>
         
  
         
 
          <br />
          <div class="custom-control custom-checkbox">

            <span *ngIf="casePenaltyEdited.isFinancial">نوع العقوبة : عقوبة مالية</span>
            <span *ngIf="!casePenaltyEdited.isFinancial">نوع العقوبة : عقوبة ادارية</span>


          </div>

          <div class="form-group mt-1">
            <div style="display: flex; flex-wrap: nowrap; height: 30px">
              <label for="amount">{{ "PenaltyAmount" | translate }}</label>
            </div>
            <input [readonly]="!isFinancial" #AmoutPenalty="ngModel" #name="ngModel"
              [(ngModel)]="casePenaltyEdited.amount" type="number" class="form-control" id="amount"
              min="{{minAmountPenality}}" max="{{maxAmountPenality}}" name="amount" required />
            <span *ngIf="AmoutPenalty.invalid" class="alert" style="
                  color: red;
                  white-space: nowrap;
                  line-height: 0;
                  padding: 0;
                  margin-top: 8px;
                ">
              <div *ngIf="AmoutPenalty.errors?.min">قيمة العقوبة أقل من الحد الأدني للعقوبة ({{minAmountPenality}})
              </div>
              <div *ngIf="AmoutPenalty.errors?.max">قيمة العقوبة أكثر من الحد الأقصي للعقوبة ({{maxAmountPenality}})
              </div>

            </span>
          </div>
        </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger"
        [disabled]="PenaltyDescription.invalid || (isFinancial == true && AmoutPenalty.invalid )"
        (click)="onEditPenalty()">
        {{ "Edit" | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
        {{ "NO" | translate }}
      </button>
    </div>
  </ng-template>

  <ng-template #Recivers let-modal>
    <div class="modal-header" style="justify-content: center">
      <h4 class="modal-title" id="modal-basic-title">
        {{'reportDetails' | translate }}
      </h4>
      <a style="position: absolute;left:50px" (click)="print()" class="btn btn-outline-dark">
        <i class="fa fa-print"></i> {{'print' | translate }}
      </a>

    </div>
    <div class="modal-body text-center">
      <table class="table table-striped mt-3" *ngIf="Recivers1.length > 0">
        <thead class="thead-dark">
          <tr>
            <th scope="col">{{ "NationalIdentity" | translate }}</th>
            <th scope="col">{{ "OffenderName" | translate }}</th>
            <th scope="col">الرسالة</th>
            <th scope="col">تاريخ التبليغ</th>

            <th scope="col">{{ "Seen" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item1 of Recivers1">
            <td>{{ item1.nid }}</td>
            <td>{{ item1.name }}</td>
            <td>
              <p style="direction: ltr">
                {{ item1.nabaaMessage }}
              </p>
            </td>
            <td>
              {{ item1.createdOn | toDateTime}}

            </td>
            <td>
              <i *ngIf="item1.isViewed" class="available fa fa-check-circle"></i>
              <i *ngIf="!item1.isViewed" class="fa fa-times"></i>

              <p *ngIf="item1.isViewed"> {{ item1.viewedOn | toDateTime }} </p>
            </td>
          </tr>
        </tbody>
      </table>
      <!--<h3 style="text-align: center;" *ngIf="Recivers1.length == 0">
          عفواً لا تظهر تفاصيل المبلغيين الا بعد إصدار القرار
        </h3>-->
    </div>
    <div class="modal-footer" style="justify-content: end">
      <button class="btn btn-danger" (click)="modal.close()">{{'Close'|translate}}</button>
    </div>

  </ng-template>


</div>